<template>
  <div class="info">
    <lb-table
      border
      v-loading="loading"
      v-horizontal-scroll="'always'"
      :column="columns"
      :data="page.list"
      pagination
      :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      @size-change="handleSizeChange"
      @p-current-change="handleCurrentChange"
    >
    </lb-table>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  props: {
    phone: {
      type: String,
      default: ''
    },
  },
  components: {
    LbTable
  },
  data () {
    return {
      name: 'cdd',
      list: [{
        name: 'cdd'
      },
      {
        name: 'cdd'
      }, {
        name: 'cdd'
      }, {
        name: 'cdd'
      }
      ],
      columns: [
        { label: '充值方式', prop: 'typeLabel', minWidth: '120' },
        {
          label: '充值金额', prop: 'money', minWidth: '220',
          render: (h, scope) => {
            return (
              <div> {Number(scope.row.money).toFixed(2)}</div>
            )
          }
        },
        { label: '充值时间', prop: 'inTime', minWidth: '120' },
        { label: '充值状态', prop: 'statusLabel', minWidth: '120' },

      ],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      loading: false
    }
  },
  watch: {
    phone (val, vall) {
      this.phone = val
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    handleCurrentChange (currentChange) {
      this.page.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.page.pageSize = sizeChange
      this.fetchData()
    },
    fetchData () {
      let data = {
        phone: this.phone,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      this.$api.matrixServerGetRechargeRecordList(data).then(res => {
        this.page.list = res.data.list
        this.page.totalNum = res.data.totalNum
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.info {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>

